import { gql } from '@apollo/client';

export const ACADEMIC_CALENDAR_ITEMS = gql`
  query academic_calendar_item($where: academic_calendar_item_bool_exp) {
    academic_calendar_item(where: $where) {
      id
      name
      type
      startDate
      endDate
    }
  }
`;
